import React from 'react';
import { LgpHero, ILgpHero } from '@sky-it-livedata/livedata-sports-design-system';
import { lgpHeroWidget } from '@sky-it-livedata/livedata-live-match-pages-widgets';

import { getModelFromUseService } from '../../utils/props-validator';
import { IModelWrapper } from '../../typings/common-types';
import { useMotorsportService as useService } from '../hooks/useService';

export interface ILgpHeroWrapper extends IModelWrapper<ILgpHero> {}
const LgpHeroWrapper = ({ query, initialModel, live = true }: ILgpHeroWrapper) => {
  const { model } = useService({
    live,
    query,
    widget: lgpHeroWidget,
    initialValue: initialModel,
  });

  const compontentModel: ILgpHero = getModelFromUseService(model);

  return <LgpHero {...compontentModel} />;
};

export default LgpHeroWrapper;
